module.exports = __webpack_public_path__ + "media/images/web/favicon/apple-icon-114x114-948941e50b97eafa07ed112ef5ec4d11.png";